/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HchbBranchList } from './HchbBranchList';
import {
    HchbBranchListFromJSON,
    HchbBranchListFromJSONTyped,
    HchbBranchListToJSON,
    HchbBranchListToJSONTyped,
} from './HchbBranchList';

/**
 * 
 * @export
 * @interface FindAllHchbBranches200Response
 */
export interface FindAllHchbBranches200Response {
    /**
     * 
     * @type {HchbBranchList}
     * @memberof FindAllHchbBranches200Response
     */
    data?: HchbBranchList;
}

/**
 * Check if a given object implements the FindAllHchbBranches200Response interface.
 */
export function instanceOfFindAllHchbBranches200Response(value: object): value is FindAllHchbBranches200Response {
    return true;
}

export function FindAllHchbBranches200ResponseFromJSON(json: any): FindAllHchbBranches200Response {
    return FindAllHchbBranches200ResponseFromJSONTyped(json, false);
}

export function FindAllHchbBranches200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllHchbBranches200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : HchbBranchListFromJSON(json['data']),
    };
}

export function FindAllHchbBranches200ResponseToJSON(json: any): FindAllHchbBranches200Response {
    return FindAllHchbBranches200ResponseToJSONTyped(json, false);
}

export function FindAllHchbBranches200ResponseToJSONTyped(value?: FindAllHchbBranches200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': HchbBranchListToJSON(value['data']),
    };
}

